import { Button } from 'dingtalk-design-mobile';
import './AdviceDetail.less'
import useHistory from '@/hooks/useHistory'
import { useSearchParams } from 'react-router-dom'
import { useEffect, useState } from 'react';
import { _getAdviceDetail } from '@/api/user'
import { htmlDecode } from '@/utils/tool';

const AdviceDetail = () => {
  const [ params ] = useSearchParams()
  const id = params.getAll('id')[0]
  const history = useHistory()

  const [detail, setDetail] = useState({
    id: '',
    address: '',
    content: '',
    title: '',
    submitDate: '',
  })

  const goBack = () => {
    history.back(2)
  }

  const getDetail = () => {
    _getAdviceDetail({ id }).then(res => {
      const [ d, result ] = res
      if (d && result) {
        setDetail({
          ...result,
          content: htmlDecode(result.content),
          address: htmlDecode(result.address)
        })
      }
    })
  }

  useEffect(() => {
    getDetail()
  }, [])

  return (
    <div className='pg-advice-detail'>
    <img className='header' src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/advice/advice-header.png' />
    <div className='pg-advice-detail--wrap'>
      <div className='pg-advice-detail--container'>
        <div className='content'>
          <div className='title'>{ detail.title }</div>
          <div className='time'>提交时间：{ detail.submitDate }</div>
          <div>{ detail.content }</div>
        </div>
        <Button className='btn' onClick={goBack}>返回首页</Button>
      </div>
    </div>
  </div>
  )
}

export default AdviceDetail